export default "__VITE_ASSET__DbEMA9ok__"